import {
    Flex,
} from "@chakra-ui/react";

import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import { getApi } from "common/services/api";
import { HasAccess } from "../../../../common/utils/accessUtils";
import Spinner from "common/components/spinner/Spinner";
import ViewEdit from "common/components/viewEdit";
import Overview from "common/components/viewEdit/overview";
import { toast } from "react-toastify";
import { constant } from "common/constant";

const EditWorkflow = (props) => {
    const param = useParams();
    const { id } = param;
    const user = JSON.parse(localStorage.getItem("user"));
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [edit, setEdit] = useState(false);
    const isEdit = location.state?.isEdit || false;
    const [data, setData] = useState([]);
    const [permission,] = HasAccess([
        "Tasks",
        "Contacts",
        "Leads",
    ]);
    const size = "lg";
    const [initialValues, setInitialValues] = useState({
        ruleName: "",
        allModule: "",
        executeOn: "",
        modifiedOn: "",
        status: null,
        version: null,
    });

    const fetchData = async () => {
        if (id) {
            try {
                setIsLoading(true);
                let result = await getApi("api/workflows/", id);
                const fetchedData = result?.data;
                console.log(fetchedData, 'fd')


                setData(fetchedData.data);
            } catch (e) {
                toast.error(constant.somethingWrong);
            } finally {
                setIsLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, [id]);


    return (
        <div>

            {isLoading ? (
                <Flex justifyContent={"center"} alignItems={"center"} width="100%">
                    <Spinner />
                </Flex>
            ) : (
                <>
                    <ViewEdit
                        title={"Workflow Rules"}
                        tabs={{
                            "Overview":
                                <Overview
                                    user={user}
                                    permission={permission}
                                    overviewPageTitle="Edit Workflow Rule"
                                    menuSelectedDeleteItem={param?.id}
                                    title={'Workflow Rules'}
                                    getData={fetchData}
                                    isDataLoding={isLoading}
                                    initialValues={initialValues}
                                    setInitialValues={setInitialValues}
                                    isOpen={edit}
                                    size={size}
                                    isManual={true}
                                    onClose={setEdit}
                                    setLeadData={setData}
                                    leadData={data}
                                    isEdit={isEdit}
                                    moduleId={data?._id}
                                />
                        }}

                        backRoute={"/crm/workflow-rules"}
                    />
                </>
            )}

        </div>
    );
};

export default EditWorkflow;
